import React from 'react';
import { InputComponent } from '../components/input.component'

export function InputContainer({ isLoading, min, optionName, readOnly, isDateTimePicker, disablePast, valueField, size, key, onTypeahead, icon, multiline, rows, type, name, label, value, onValueChange, list, className, labelField, isDisabled, placeholder, isRequired }: any) {
  return (<InputComponent
    className={className}
    icon={icon}
    min={min}
    isDisabled={isDisabled}
    isRequired={isRequired}
    isLoading={isLoading}
    key={key}
    label={label}
    labelField={labelField}
    list={list}
    multiline={multiline}
    name={name}
    isDateTimePicker={isDateTimePicker}
    disablePast={disablePast}
    onTypeahead={onTypeahead}
    onValueChange={onValueChange}
    placeholder={placeholder}
    rows={rows}
    size={size}
    type={type}
    value={value}
    valueField={valueField}
    readOnly={readOnly}
    optionName={optionName}
  />)
}

